export default __webpack_public_path__ + "static/media/tick-square.2b27793d.svg";